// eslint-disable-next-line import/prefer-default-export
export const copyStyles = (node, styles) => {
    const { fontSize, fontFamily, fontWeight, fontStyle, letterSpacing, textTransform } = styles;
    /* eslint-disable no-param-reassign */
    node.style.fontSize = fontSize;
    node.style.fontFamily = fontFamily;
    node.style.fontWeight = fontWeight;
    node.style.fontStyle = fontStyle;
    node.style.letterSpacing = letterSpacing;
    node.style.textTransform = textTransform;
    /* eslint-enable no-param-reassign */
};
